import React from 'react';
import { Chip } from '@mui/material';
function SquareChip(props) {
    const { sx, ...rest } = props;
    return React.createElement(Chip, { ...rest, sx: { borderRadius: 1, ...sx } });
}
export default SquareChip;
